module.exports = __webpack_public_path__ + "assets/ce20db9d96988fe79199e8a7ebb49031.png";